const MAX_EDGE = 1920;
const QUALITY = 0.85;

export const compressImage = async (file) => {
  if (!file || !file.type.startsWith("image/") || file.type === "image/gif") return file;
  try {
    const bitmap = await createImageBitmap(file, { imageOrientation: "from-image" });
    const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bitmap.width * scale);
    canvas.height = Math.round(bitmap.height * scale);
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close?.();
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", QUALITY));
    if (!blob) return file;
    const name = (file.name.replace(/\.[^.]+$/, "") || "photo") + ".jpg";
    return new File([blob], name, { type: "image/jpeg" });
  } catch (e) {
    console.error("Image compression failed, uploading original", e);
    return file;
  }
};
